/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';
var EMPTY_PROMISE = Odigeo._.constant($.Deferred().promise());
var EMPTY_WIDGET = Odigeo._.constant({
    execute: EMPTY_PROMISE,
    get: EMPTY_PROMISE,
});
var DisableWidget = function(widgets) {
    this.widgets = widgets;
};

DisableWidget.prototype.deactivate = function(nameList) {
    Odigeo._.each(Odigeo._.isString(nameList) ? new Array(nameList) : nameList, function(name) {
        this.widgets[name] = EMPTY_WIDGET;
    }, this);
};

module.exports = DisableWidget;
